const readFileAsDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });

const canvasToBlob = (canvas, type, quality) =>
  new Promise((resolve) => {
    canvas.toBlob(resolve, type, quality);
  });

const drawScaledToCanvas = (img, maxDim = 1920) => {
  const scale = Math.min(1, maxDim / Math.max(img.width || 1, img.height || 1));
  const width = Math.max(1, Math.round((img.width || 1) * scale));
  const height = Math.max(1, Math.round((img.height || 1) * scale));
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;
  ctx.drawImage(img, 0, 0, width, height);
  return canvas;
};

export const optimizeImageForUpload = async (inputFile, options = {}) => {
  if (!inputFile || !inputFile.type?.startsWith('image/')) return inputFile;
  const maxBytes = options.maxBytes || 1.6 * 1024 * 1024;
  const maxDim = options.maxDim || 1920;
  if (inputFile.size <= maxBytes) return inputFile;

  const dataUrl = await readFileAsDataUrl(inputFile);
  const img = await loadImage(dataUrl);
  const canvas = drawScaledToCanvas(img, maxDim);
  if (!canvas) return inputFile;

  let quality = 0.86;
  let blob = await canvasToBlob(canvas, 'image/jpeg', quality);
  while (blob && blob.size > maxBytes && quality > 0.55) {
    quality -= 0.08;
    blob = await canvasToBlob(canvas, 'image/jpeg', quality);
  }
  if (!blob || blob.size >= inputFile.size) return inputFile;

  const baseName = (inputFile.name || 'artwork').replace(/\.[^.]+$/, '');
  return new File([blob], `${baseName}-optimized.jpg`, { type: 'image/jpeg' });
};

export const createThumbnailForUpload = async (inputFile, options = {}) => {
  if (!inputFile || !inputFile.type?.startsWith('image/')) return null;
  const maxDim = options.maxDim || 640;
  const quality = options.quality || 0.72;

  const dataUrl = await readFileAsDataUrl(inputFile);
  const img = await loadImage(dataUrl);
  const canvas = drawScaledToCanvas(img, maxDim);
  if (!canvas) return null;
  const blob = await canvasToBlob(canvas, 'image/jpeg', quality);
  if (!blob) return null;

  const baseName = (inputFile.name || 'artwork').replace(/\.[^.]+$/, '');
  return new File([blob], `${baseName}-thumb.jpg`, { type: 'image/jpeg' });
};
